module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "frontmatter",
      "id": "ser"
    }
  }, [_c('p', {
    staticClass: "sert",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "ii",
      "epub:type": "pagebreak",
      "id": "pii",
      "role": "doc-pagebreak"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "75",
      "src": "images/logo-Opera-Lab.jpg",
      "width": "111"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sert",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Opera Lab: Explorations in History, Technology, and Performance")]), _vm._v(" "), _c('p', {
    staticClass: "sered",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("A series edited by David J. Levin & Mary Ann Smart")]), _vm._v(" "), _c('p', {
    staticClass: "serah",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("ADVISORY BOARD")]), _vm._v(" "), _c('p', {
    staticClass: "seraft",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Carolyn Abbate")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Gundula Kreuzer")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Emanuele Senici")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Benjamin Walton")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Emily Wilbourne")]), _vm._v(" "), _c('p', {
    staticClass: "serah",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("ALSO PUBLISHED IN THE SERIES")]), _vm._v(" "), _c('p', {
    staticClass: "seraft",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', [_vm._v("Music in the Present Tense: Rossini’s Italian Operas in Their Time")])]), _vm._v(" "), _c('p', {
    staticClass: "serau",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Emanuele Senici")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', [_vm._v("Singing Sappho: Improvisation and Authority in Nineteenth-Century Italian Opera")])]), _vm._v(" "), _c('p', {
    staticClass: "serau",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Melina Esse")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', [_vm._v("Networking Operatic Italy")])]), _vm._v(" "), _c('p', {
    staticClass: "serau",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Francesca Vella")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', [_vm._v("“Don Giovanni” Captured: Performance, Media, Myth")])]), _vm._v(" "), _c('p', {
    staticClass: "serau",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Richard Will")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-221e8454","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-bentley-0003.vue
// module id = 60
// module chunks = 0